module.exports = ".tab-heading{\r\n    color: #b71c1c;\r\n}"